export default "__VITE_ASSET__DRlsqOiL__"